import axios from "axios";
import { api_url } from "../config";

const base_url = api_url;

export const checkLoggedIn = async () => {
  return axios.get(`${base_url}/auth/checkAccess`, {
    withCredentials: true
  });
};

export const authenticateUser = async id_token => {
  return axios.post(
    `${base_url}/auth/authenticateUser`,
    {
      id_token
    },
    {
      withCredentials: true
    }
  );
};

export const logout = async () => {
  return axios.post(
    `${base_url}/auth/logout`,
    {},
    {
      withCredentials: true
    }
  );
};
